export const FORM_MOBILE_START = 'start'
export const FORM_LOGIN = 'login'
export const FORM_SIGNUP = 'signup'
export const FORM_PASSWORD_RECOVERY = 'passwordRecovery'
export const FORM_SMS = 'smscode'
